import type { CddVolumeOptions } from './constants';

export const getCddVolumeOptionI18nKey = (option: CddVolumeOptions): string => option.toLowerCase();
